import { render, staticRenderFns } from "./CustomizeGif.vue?vue&type=template&id=53e581b4&scoped=true&"
import script from "./CustomizeGif.vue?vue&type=script&lang=js&"
export * from "./CustomizeGif.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeGif.vue?vue&type=style&index=0&id=53e581b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e581b4",
  null
  
)

export default component.exports